import { http } from "utils/http";

export function getServerConfig(pass: string): Promise<server.IServerConfigData> {
    return http.get('http://ssr.thisjs.com/config.php', { params: { pass } });
}

export function updateServerConfig(pass: string): Promise<server.IUpdateResult> {
    return http.get('http://ssr.thisjs.com/update.php', { params: { pass } });
}